// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"ca920fae","350":"64b77a96","399":"1ba5e2ca","507":"983bedc0","540":"db917013","545":"85b46a4c","604":"cd70fb67","648":"221fe842","738":"ce25fd79","740":"c2c8aa2a","869":"f484c59b"}[chunkId] + ".chunk.js";
};